/** Team traffic is hard-blocked before init, so no events and no replay are captured. */
const INTERNAL_EMAIL_SUFFIX = '@parcelengineering.com';

/**
 * True when the email belongs to the team. Anonymous visitors (no email) are
 * treated as external, because on marketing and docs a hard block is impossible
 * and PostHog's project-level internal-user filter handles those surfaces.
 */
export function isInternal(email: string | null | undefined): boolean {
  if (!email) return false;
  return email.trim().toLowerCase().endsWith(INTERNAL_EMAIL_SUFFIX);
}
